import React from 'react';
import clsx from 'clsx';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return (
    <div className={clsx(
      "bg-white rounded-xl shadow-lg p-6 space-y-6",
      "border border-gray-100",
      className
    )}>
      {children}
    </div>
  );
}